import React from 'react';
import { Hero } from '../components/Hero';
import { VideoSection } from '../components/VideoSection';
import { Testimonials } from '../components/Testimonials';
import { PainPoints } from '../components/PainPoints';
import { WhatsIncluded } from '../components/WhatsIncluded';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { StickyButton } from '../components/StickyButton';
export function Home() {
  return <main className="w-full relative pb-24 md:pb-0" data-id="element-133">
      <Hero data-id="element-134" />
      <VideoSection data-id="element-135" />
      <Testimonials data-id="element-136" />
      <PainPoints data-id="element-137" />
      <WhatsIncluded data-id="element-138" />
      <Pricing data-id="element-139" />
      <FAQ data-id="element-140" />
      <FinalCTA data-id="element-141" />
      <StickyButton data-id="element-142" />
    </main>;
}